import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import ptLocale from 'date-fns/locale/pt';

import GlobalStyle from './styles/global';
import GlobalManutencaoStyle from './styles/global-manutencao';
import './styles/App.css';
import theme from './config/theme';
import Routes, {ManutencaoRouter} from './routes';
import { AuthProvider } from './contexts/auth';
import { ContatoProvider } from 'contexts/contato';
import { TrackingProvider } from 'contexts/tracking';
import { BrowserRouter } from 'react-router-dom';
import ClarityTracker from './components/Clarity/clarityTracker';

import { RecaptchaFieldProvider } from 'contexts/recaptchaField';
declare global {
  interface Window {
    my_global_var: string;
  }
}

const isManutencaoAtiva = process.env.REACT_APP_MANUTENCAO === 'true';
console.log('EM', isManutencaoAtiva);

const App = () => {
  if (isManutencaoAtiva) {
    return (
      <>
        <BrowserRouter>
          <ClarityTracker />
          <ManutencaoRouter />
          <GlobalManutencaoStyle />
        </BrowserRouter>
      </>
    );
  }

  return (
    <AuthProvider>
      <TrackingProvider>
        <ContatoProvider>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
              <ThemeProvider theme={theme}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptLocale}>
                  <BrowserRouter>
                    <ClarityTracker />
                    <RecaptchaFieldProvider>
                      <Routes />
                      <GlobalStyle />
                      <ToastContainer autoClose={10000} />
                    </RecaptchaFieldProvider>
                  </BrowserRouter>
                </LocalizationProvider>
              </ThemeProvider>
            </MuiThemeProvider>
          </StyledEngineProvider>
        </ContatoProvider>
      </TrackingProvider>
    </AuthProvider>
  );
};

export default App;
